import { ElectronAPI } from '../base/ElectronAPI';
import { IPCEventType } from '../base/types';

export class SnapshotDumpAPI extends ElectronAPI {
  async listApps(): Promise<string[]> {
    const response = await this.requestContextKit(
      IPCEventType.getSnapshotDumpApps,
      {}
    );
    return response.apps ?? [];
  }

  async getArchives(
    appNames: string[]
  ): Promise<{ appName: string; filePath: string; fileName: string }[]> {
    const response = await this.requestContextKit(
      IPCEventType.getSnapshotDumpArchives,
      { appNames }
    );
    return response.archives ?? [];
  }
}
